import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import { DocumentsList, DocumentUpload } from './documents';
import { ContractsList } from './contracts';
import { accountRoles } from '../../../common/enums';
import documentTypes from '../../../common/enums/accountDocumentTypes';
import ShowPsd2Button from './psd2/ShowPsd2Button';
import {OpenFileLink} from "../../../common/components/data-display";

const isIDDocument = (doc) => {
  return doc.type == documentTypes.ID_CARD_SCAN_FRONT || doc.type == documentTypes.ID_CARD_SCAN_BACK;
}

const sortIDsToTop = (documents) => {
  return [...documents.filter(isIDDocument),...documents.filter((doc)=> !isIDDocument(doc))]
}

const sortDocumetsByCreatedAt = (documents) => {
  return documents.sort((a, b) => b.file.createdAt.localeCompare(a.file.createdAt));
}

const AccountDocuments = ({
  accountRole,
  contracts,
  documentUploadedByAdmin,
  documentUploadedByUser,
  onAccountDocumentRemove,
  onCancel,
  onFileTypeChange,
  onSave,
  onUpload,
  onUploadedFileRemove,
  t,
  token,
  accountId,
  uploadedFilesList,
  psd2Available,
  loans,
  onOpenPsd2,
}) => (
  <div>
    {psd2Available && (
      <div className="padded" style={{ marginTop: 0 }}>
        <h2 style={{ marginBottom: 8 }}>{t('Bankové výpisy cez PSD2')}</h2>
        <p style={{ marginTop: 0, marginBottom: 12 }}>
          {t(
            'Pre tohto používateľa sú bankové výpisy importované cez PSD2. Namiesto otvárania dokumentov použite nasledujúce tlačidlo pre zobrazenie výpisov a agregácií.'
          )}
        </p>
        <ShowPsd2Button loans={loans} onOpenPsd2={onOpenPsd2} psd2Enabled />
      </div>
    )}

    {accountRole !== accountRoles.ADMINISTRATOR && (
      <div className="padded">
        <h2>{t('Dokumenty nahraté používateľom')}</h2>
        <DocumentsList
          token={token}
          documents={sortIDsToTop(sortDocumetsByCreatedAt(documentUploadedByUser))}
          onFileTypeChange={onFileTypeChange}
          onAccountDocumentRemove={onAccountDocumentRemove}
          showCreatedAt={true}
        />
      </div>
    )}

    <div className="padded">
      <h2>{t('Dokumenty nahraté administrátorom')}</h2>
      <DocumentsList
        token={token}
        documents={documentUploadedByAdmin}
        onFileTypeChange={onFileTypeChange}
        onAccountDocumentRemove={onAccountDocumentRemove}
        showCreatedAt={true}
      />
    </div>

    {accountRole !== accountRoles.ADMINISTRATOR && (
      <div className="padded">
        <h2>{t('Vygenerované zmluvy')}</h2>
        <ContractsList token={token} documents={contracts} accountRole={accountRole} />
      </div>
    )}

    <div className="padded">
      <h2>{t('Nahrať nové dokumenty')}</h2>
      <DocumentUpload
        uploadedFilesList={uploadedFilesList}
        onUpload={onUpload}
        onRemove={onUploadedFileRemove}
      />
    </div>

    <Button size="default" type="primary" onClick={onSave}>
      {t('Uložiť')}
    </Button>
    <Button size="default" className="btn-inline" onClick={onCancel}>
      {t('Zrušiť')}
    </Button>


    {accountRole !== accountRoles.ADMINISTRATOR && (
        <div style={{ margin: '30px 0', textAlign: 'right'}}>
          <OpenFileLink isButton href={`${process.env.REACT_APP_API_URL}/account/loanRegistrationLogExport?token=${token}&accountId=${accountId}`} >
            {t('Export aktivity na webe')}
          </OpenFileLink>
        </div>
    )}

  </div>
);

AccountDocuments.propTypes = {
  accountRole: PropTypes.string.isRequired,
  contracts: PropTypes.array.isRequired,
  documentUploadedByAdmin: PropTypes.array.isRequired,
  documentUploadedByUser: PropTypes.array.isRequired,
  onAccountDocumentRemove: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onFileTypeChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  onUploadedFileRemove: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  uploadedFiles: PropTypes.array,
  uploadedFilesList: PropTypes.array.isRequired,
  // NEW:
  psd2Available: PropTypes.bool,
  loans: PropTypes.array,
  onOpenPsd2: PropTypes.func,
  accountId: PropTypes.string.isRequired,
};

AccountDocuments.defaultProps = {
  psd2Available: false,
  onOpenPsd2: () => {},
};

export default translate()(AccountDocuments);



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountDocuments.js